export const currencies = [
  "USD",
  "TWD",
  "EUR",

  "AUD",
  "BGN",
  "BND",
  "BOB",
  "BRL",
  "CAD",
  "CHF",
  "CLP",
  "CNY",
  "COP",
  "CZK",
  "DKK",
  "EGP",
  "FJD",
  "GBP",
  "HKD",
  "HRK",
  "HUF",
  "IDR",
  "ILS",
  "INR",
  "JOD",
  "JPY",
  "KES",
  "KRW",
  "LKR",
  "LTL",
  "MAD",
  "MXN",
  "MYR",
  "NOK",
  "NZD",
  "PEN",
  "PHP",
  "PKR",
  "PLN",
  "RON",
  "RSD",
  "RUB",
  "SAR",
  "SEK",
  "SGD",
  "THB",
  "TND",
  "TRY",
  "UAH",
  "UYU",
  "VEF",
  "VND",
  "ZAR",
];
